import React, { useEffect } from "react";

import { useFormik } from "formik";
import * as Yup from "yup";
import List_It_Logo from "../assets/image/ListIt.png";
import './Styles/Login.css'
import { Link, useNavigate } from "react-router-dom";
import { NavigationRoutes } from "../../constant/Routes";
import { ColorTheme } from "../../constant/ColorTheme";
import { fetchUsers } from "../../redux/actionDispatcher/auth/authDispatcher";
import { connect } from "react-redux";
import LoaderButton from "../common/LoaderButton";
import { isAuthenticated } from "../../helpers/AdminAuthentication";
function Login({ userData, fetchUsers }) {
  var navigate = useNavigate();
  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid Email Format*").required("Please Enter Email"),
    password: Yup.string().required("Please Enter Password"),
  });
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema,


    onSubmit: (values) => {
      // // console.log(values);
      const data = {
        email: formik.values.email,
        password: formik.values.password,
      };
      console.log(data);
      // navigate(NavigationRoutes.ADMIN_DASHBOARD);
      //passing the data in fetchUsers which contain the dispatch method
      //Add new lines and response in fetchUsers function
      fetchUsers(data,navigate);
    },
  });
  useEffect(() => {
    if (isAuthenticated()) {
      navigate(NavigationRoutes.ADMIN_DASHBOARD);
    }
  }, [navigate]);
  return ( <>
   <div
          className="position-absolute top-50 start-50 translate-middle login-card "
        >

          <form onSubmit={formik.handleSubmit} className="login-form">
            <div className="d-flex justify-content-center">
              <img
                src={List_It_Logo}
                alt="logo list"
                height={100}
                style={{ alignItems: "center", }}
              />{" "}
              <br />
            </div>
             <div className="">
                          <h4 className="h4 fw-bold" style={{ color: ColorTheme.colors.primary }}> <b> Sign In </b></h4>
                          <p className="p mb-3 " style={{ color: "black" }}>  Please enter your details.  </p>
                        </div>
            <div className="mb-3 input-login-box">
              <input
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="email"
                type="text"
                className="form-control login-input mb-3"
                placeholder="Email"
                disabled={userData.loading}
              />
              {formik.errors.email && formik.touched.email ? (
                <div className="text-danger fs-6 mb-2 ">{formik.errors.email}</div>
              ) : (
                ""
              )}
              <input

                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="password"
                type="password"
                className="form-control login-input "
                placeholder="Password"
                disabled={userData.loading}
              />
              {formik.errors.password && formik.touched.password ? (
                <div className="text-danger fs-6">{formik.errors.password}</div>
              ) : (
                ""
              )}
            </div>
            <div className="d-flex justify-content-end mb-1">
              <Link
                disabled={userData.loading}
                to={NavigationRoutes.FORGOT_PASSWORD}
                style={{
                  color: "gray",
                  cursor: "pointer",
                  textDecoration: "none",
                  marginBottom: "5px"
                }}
              >
                Forgot password
              </Link>
            </div>
          
            <button
              className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
              type="submit"
              disabled={userData.loading}
            >
              {/* used loader for button here ============= */}
              {
              userData.loading ? (<LoaderButton />) :
              
              "Submit"}
            </button>
            
          </form>
        </div>
  </>
    );
}
//Getting the state from the store
const mapStateToProps = (state) => {
  return {
    userData: state.auth,
  };
};

//passing the userData in fetchUsers function and also dispatch method
const mapDispatchToProps = (dispatch) => {
  return {
    fetchUsers: (data,navigate) => dispatch(fetchUsers(data,navigate)),
  };
};

//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(Login);

